firebird
    .directive('canvasBanner', [
        'templateCache',
        'helperService',
        function (templateCache, helperService) {
            return {
                restrict: 'E',
                template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'canvas-banner.html')
            };
        }
    ])
    .directive('canvasBannerContent', [
        '$rootScope',
        '$window',
        '$timeout',
        function ($rootScope, $window, $timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var bannerHeight = 0;

                    //Watch for changes in the banner message
                    attrs.$observe('canvasBannerContent', function (newValue) {
                        //If there is a change in message, broadcast the banner height
                        //so that the Header/Body divs can reposition themselves
                        //
                        //The timeout is so that this occurs at the end of a digest cycle...
                        //Otherwise, the outerHeight won't be accurate
                        //
                        // outerHeight is not accurate when browser is zoomed. Use visible check too.
                        $timeout(function () {
                            var currentHeight = element.parent().is(':visible') ? element.parent().outerHeight() : 0;
                            if (bannerHeight !== currentHeight) {
                                bannerHeight = currentHeight;
                                $rootScope.$broadcast('canvas-banner-height-changed', bannerHeight);
                            }
                        });
                    });
                }
            };
        }
    ]);
